export default __webpack_public_path__ + "media/images/clients-05-150x86-d956ed93d917df9a7acf49d3196c0d98.png";